const images = {
  // logo: require('~/assets/images/logo.svg').default,
  tenten: require('~/assets/svg').tenten,
  vnnicLogo: require('~/assets/vnnic_logo.png'),
  vnnicLogo2: require('~/assets/vnnic_logo-01_0.png'),
  bannerVideo: require('~/assets/videobannercv.mp4'),
  githubBanner: require('~/assets/github.jpg'),
  backgroundImg: require('~/assets/background.png'),
  imgtemp: require('~/assets/IMG_988.jpg'),
  avatar: require('~/assets/avatar.png'),
  avatar2: require('~/assets/avt9799.jpg'),
  tiktokScreen: require('~/assets/tiktokscrenshot.jpg'),
  img01: require('~/assets/img0002.jpeg'),
  bgrSocialDark: require('~/assets/20187303_6184604.jpg'),
  bgrSocialLight: require('~/assets/freepik__adjust__41315.png'),
  flyingBirth: require('~/assets/flying-7288.gif'),
  angry: require('~/assets/angry-2498.gif'),
  banphim: require('~/assets/banphimco.png'),
  chuot: require('~/assets/chuotkhongday.png'),
  giado: require('~/assets/giado.png'),
  manhinh: require('~/assets/manhinh.png'),
  avttiktok: require('~/assets/avttiktok.png'),
  longga: require('~/assets/longga.gif'),
  airplane: require('~/assets/airplane-19754.gif'),
  tiktok2: require('~/assets/tik-tok_3046114.png'),
  tiktok2Dark: require('~/assets/tiktok_5968812.png'),
  bgr21: require('~/assets/bgr0001.jpg'),
  bgr22: require('~/assets/bgr00002.jpg'),
  bgr23: require('~/assets/bgt00003.jpg'),
  bgr24: require('~/assets/img0005.jpg'),
  bgr25: require('~/assets/img0004.jpg'),
  hiimg: require('~/assets/avttiktok.png'),
  phoneFrame: require('~/assets/phoneFrame.png'),
  orderMain: require('~/assets/orderweb/photo-1516321318423-f06f85e504b3.jpg'),
  orderOther1: require('~/assets/orderweb/1.svg').default,
  orderOther2: require('~/assets/orderweb/2.svg').default,
  orderOther3: require('~/assets/orderweb/3.svg').default,
  orderOther4: require('~/assets/orderweb/4.svg').default,
};

export default images;
